module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option-general', {
    attrs: {
      "value": "exit",
      "label": _vm.$t('edit.sidebar.when_leave_the_page')
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1961efb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionmode/options/Exit.vue
 ** module id = 772
 ** module chunks = 1
 **/